<template>
  <span>You successfully created new scheme with your data</span>
</template>

<script>
export default {
  name: "created-scheme"
};
</script>
